import { User } from '@/model/user'
import { createAppAsyncThunk } from '@/redux/utils'
import { requestBaeApi } from '@/utils/axios'

export const userNamespace = 'user'

export interface ReadUsersByConversationsParams {
  creatorId: number
  conversationIds: number[],
}

export const readUsersByConversations = createAppAsyncThunk(
  `${userNamespace}/readUsersByConversations`,
  async ({
    creatorId,
    conversationIds,
  }: ReadUsersByConversationsParams) => {
    const fanList = []
    for (const conversationId of conversationIds) {
      const result = await requestBaeApi<User>({
        creatorId,
        url: `/api/v1/profile/${conversationId}`,
      })
      fanList.push(result.data)
    }
    return fanList
  },
)
